module.exports = __webpack_public_path__ + "static/media/emojis_07.4658ac99.svg";